import { CDN_URL } from '../../config.js';

export const EYE_STYLE_CATEGORIES = [
  { id: 'colors-of-the-iris', label: 'Colors of the Iris' },
  { id: 'multiple-colors', label: 'Multiple colors' },
  { id: 'colors-of-the-pupils', label: 'Colors of the pupils' },
  { id: 'form-of-the-pupils', label: 'Form of the pupils' },
  { id: 'sclera', label: 'Sclera' },
  { id: 'stylistic-eyes', label: 'Stylistic eyes' },
  { id: 'makeup', label: 'Makeup' },
];

const slugify = (tag) => tag
  .toLowerCase()
  .replace(/['’]/g, '')
  .replace(/[\s_]+/g, '-')
  .replace(/-+/g, '-')
  .replace(/^-|-$/g, '');

const eye = (tag, categories) => ({
  tag,
  slug: slugify(tag),
  categories,
});

const iris = (tag) => eye(tag, ['colors-of-the-iris']);
const multi = (tag) => eye(tag, ['multiple-colors']);
const pupilColor = (tag) => eye(tag, ['colors-of-the-pupils']);
const pupilForm = (tag) => eye(tag, ['form-of-the-pupils']);
const sclera = (tag) => eye(tag, ['sclera']);
const stylistic = (tag) => eye(tag, ['stylistic-eyes']);
const makeup = (tag) => eye(tag, ['makeup']);

export const EYE_STYLES = [
  iris('aqua eyes'),
  iris('black eyes'),
  iris('blue eyes'),
  iris('brown eyes'),
  iris('green eyes'),
  iris('grey eyes'),
  iris('orange eyes'),
  iris('purple eyes'),
  iris('pink eyes'),
  iris('red eyes'),
  iris('white eyes'),
  iris('yellow eyes'),
  multi('heterochromia'),
  multi('gradient eyes'),
  multi('rainbow eyes'),
  multi('two-tone eyes'),
  pupilColor('brown pupils'),
  pupilColor('grey pupils'),
  pupilColor('orange pupils'),
  pupilColor('pink pupils'),
  pupilColor('purple pupils'),
  pupilColor('red pupils'),
  pupilColor('white pupils'),
  pupilColor('yellow pupils'),
  pupilForm('mismatched pupils'),
  pupilForm('no pupils'),
  pupilForm('butterfly-shaped pupils'),
  pupilForm('clover-shaped pupils'),
  pupilForm('cross-shaped pupils'),
  pupilForm('flower-shaped pupils'),
  pupilForm('heart-shaped pupils'),
  pupilForm('slit pupils'),
  pupilForm('solid circle pupils'),
  pupilForm('star-shaped pupils'),
  pupilForm('x-shaped pupils'),
  sclera('blue sclera'),
  sclera('black sclera'),
  sclera('blank eyes'),
  sclera('green sclera'),
  sclera('orange sclera'),
  sclera('pink sclera'),
  sclera('purple sclera'),
  sclera('red sclera'),
  sclera('solid eyes'),
  sclera('yellow sclera'),
  stylistic('tsurime'),
  stylistic('tareme'),
  makeup('eyeliner'),
  makeup('eyeshadow'),
  makeup('mascara'),
];

export const eyeStyleImageUrl = (slug) => `${CDN_URL}/data/eyes/eye_images/${slug}_small.webp`;
